import * as z from 'zod';

export const GetCreditDataRequest = z.object({});
export const GetCreditDataResponse = z.object({
  creditData: z
    .intersection(
      z.object({
        creditsUsed: z
          .number()
          .int()
          .describe(
            'Total number of word credits consumed by a site. For sites with an unlimited word credit quota, this property still reflects the number of credits used, even though no usage limit applies.'
          )
          .min(0)
          .optional()
          .nullable(),
        quotaType: z.enum(['LIMITED']).describe('Quota type.').optional(),
      }),
      z.xor([
        z.object({ limitedQuota: z.never().optional() }),
        z.object({
          limitedQuota: z
            .object({
              quota: z
                .number()
                .int()
                .describe(
                  'Total word credit allocation for the site. This includes the initial quota and any additional credits purchased through the [Translation Manager](https://support.wix.com/en/article/wix-multilingual-using-the-translation-manager).'
                )
                .optional()
                .nullable(),
            })
            .describe('Limited word credit quota.'),
        }),
      ])
    )
    .describe('Credit data.')
    .optional(),
});
export const CheckSufficientCreditsRequest = z.object({
  wordCount: z.number().int().describe('Number of words to translate.').min(0),
});
export const CheckSufficientCreditsResponse = z.object({
  sufficientCredits: z
    .boolean()
    .describe(
      'Whether the site has enough credits to translate the specified number of words.'
    )
    .optional(),
});
